import { render, staticRenderFns } from "./AssignmentOutlined.vue?vue&type=template&id=70199336&"
import script from "./AssignmentOutlined.vue?vue&type=script&lang=js&"
export * from "./AssignmentOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports